import React from "react"
import { graphql } from "gatsby"

import SurgeriesPageTemplate from "../templates/pages/surgeries"

export const query = graphql`
  query SurgeriesQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      surgeonName
      surgeonName_en
      title
      title_en
      description
      description_en
      keywords
      keywords_en
    },
    surgeryTypes: allSanitySurgeryType(sort: {order: ASC, fields: orderRank}) {
      nodes {
        title
        title_en
        Icon {
          asset {
            gatsbyImageData
          }
        }
        riveAnimation {
          asset {
            url
          }
        }
        _id
        link
        desc {
          children {
            text
          }
        }
        desc_en {
          children {
            text
          }
        }
        photos {
          _key
          _rawAsset
          asset {
            gatsbyImageData
          }
        }
      }
    }
  }
`

const IndexPage = props => {
  const { data } = props
  console.log(data)
  return (
    <SurgeriesPageTemplate data={data} />
  )
}

export default IndexPage
